// extracted by mini-css-extract-plugin
module.exports = {"followMe":"ki","linkItem":"kj","linkItemWrap":"kk","title":"kl","linkAppItemWrap":"km","iconWrap":"kn","mfollowMe":"ko","miconWrap":"kp","followMe-dark":"kq","followMeDark":"kq"};